import type { MouseEvent } from 'react';

import { parseHtml } from '@change-corgi/core/react/html';
import { Icon } from '@change-corgi/design-system/components/icon';
import { iconCheck } from '@change-corgi/design-system/icons';
import { Flex } from '@change-corgi/design-system/layout';

import { BannerWrapper } from 'src/app/shared/components/banners/layout';

import { usePageBanner } from './hooks/usePageBanner';

export function PageBanner() {
	const {
		data: { message, guestMessage },
		actions: { trackGuestMessageLinkClick },
	} = usePageBanner();

	if (!message && !guestMessage) return null;

	return (
		<>
			{message && (
				<BannerWrapper variant="success" big>
					<Flex sx={{ alignItems: 'center', gap: 8 }}>
						<Icon icon={iconCheck} size="xl" /> {message}
					</Flex>
				</BannerWrapper>
			)}
			{guestMessage && (
				<BannerWrapper
					big
					variant="purple"
					onClick={(event: MouseEvent) => {
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						if ((event.target as HTMLElement).tagName === 'A') {
							trackGuestMessageLinkClick();
						}
					}}
				>
					{parseHtml(guestMessage)}
				</BannerWrapper>
			)}
		</>
	);
}
